import { Flex } from "rebass/styled-components";
import styled, { keyframes } from "styled-components";

const circleAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Styled component for the circle loader
const CircleLoaderContainer = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #ccc;
  border-top: 4px solid #ed553b;
  border-radius: 50%;
  animation: ${circleAnimation} 1s linear infinite;
`;

function Loader() {
  return (
    <Flex
      sx={{
        backgroundColor: "rgba(255,255,255,0.95)",
        height: "100%",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <CircleLoaderContainer />
    </Flex>
  );
}

export default Loader;
